<template>
    <section id="missions" class="Missions blue-grey lighten-5">
        <div class="row">
            <div class="col s12 m12 left-text mission-item">
                <!-- <div class="title center">Missions</div> -->
                <div class="title center"><img src="/assets/images/missions.png"></div>

                <div class="col s12 m12 l12 xl8">
                    <div class="card horizontal">
                        <div class="card-image">
                            <img src="/assets/images/missions/timbethpike2.jpg">
                        </div>
                        <div class="card-stacked">
                            <div class="card-content">
                                <div class="card-image">
                                    <img src="/assets/images/missions/timbethpike.jpg">
                                </div>
                                <div class="mission-name-div">
                                    <span class="role">Missionaries</span>
                                    <span class="name">Tim & Beth Pike</span>
                                </div>
                                <p><br>
                                    Tim & Beth Pike were called by God into the mission field starting in the 2000. They have been on numerous trips to countries such as, Vanuatu, Curacao and Antigua, where they focused on bringing a Bible School ministry to each target area. They trained individuals with the goal that upon the conclusion of their trip, these newly raised leaders would continue educating their communties about the love and grace of Jesus Christ.<br><br>
                                    As a church, we have partnered with Tim & Beth for over 15 years to help finance their trips and to provide spirtual support through prayers.
                                </p>
                            </div>
                            <div class="card-action">
                                <a href="https://agmd.org/Profile/Index/67bfce94-e280-4986-b085-432927511ae0" target="_blank">Learn More</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col s12 m12 l6 xl4">
                    <div class="card">
                        <div class="card-image waves-effect activator waves-block waves-light">
                            <img class="activator" :src="missions[0].image" />
                        </div>
                        <div class="card-content">
                            <span class="card-title activator grey-text text-darken-4">{{ missions[0].title }}<i class="material-icons right">visibility</i></span>
                            <span class="date">{{ missions[0].date }} <router-link :to="{name: 'gallery' , params: { filter: missions[0].filter }}"><i class="material-icons right filter">photo</i></router-link></span>
                        </div>
                        <div class="card-reveal">
                            <span class="card-title grey-text text-darken-4">{{ missions[0].title }}<i class="material-icons right">close</i></span>
                            <p v-html="missions[0].description"></p>
                        </div>
                    </div>
                </div>

                <div class="clear"></div>

                <template v-for="(mission, index) in missions">
                    <div v-if="index > 0" :key="index" class="col s12 m12 l6 xl4">
                        <div class="card">
                            <div class="card-image waves-effect activator waves-block waves-light">
                                <img class="activator" :src="mission.image" />
                            </div>
                            <div class="card-content">
                                <span class="card-title activator grey-text text-darken-4">{{ mission.title }}<i class="material-icons right">visibility</i></span>
                                <span class="date">{{ mission.date }} <router-link :to="{name: 'gallery' , params: { filter: mission.filter }}"><i class="material-icons right filter">photo</i></router-link></span>
                            </div>
                            <div class="card-reveal">
                                <span class="card-title grey-text text-darken-4">{{ mission.title }}<i class="material-icons right">close</i></span>
                                <p v-html="mission.description"></p>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "Missions",
    data: function() {
        return {
            missions: [{
                image: "/assets/images/missions/ftgh/newark3.jpg",
                title: "Newark, NJ",
                date: "September 2019",
                description: "Continuing their desire to help those in great need and show the love of Jesus Christ, <em>For the Greater Hood</em> set up shop in Newark, New Jersey in September 2019. This time, they stocked the rented storefront with clothing and school supplies for children in surrounding shelters. Volunteers helped children and their guardians select donated clothing, shoes, books and more, which the children brought to the checkout counter. They then received a backpack filled with extra supplies and a copy of the Bible. A team of hairdressers helped children look sharp for the upcoming school year, and prayers and hugs were abundant. For more information about <em>For the Greater Hood</em>, please <a href='https://forthegreaterhood.com/' target='_blank'>click here</a>.",
                filter: "ForTheGreaterHood"
            }, {
                image: "/assets/images/missions/ftgh/paterson2.jpg",
                title: "Paterson, NJ",
                date: "March 2019",
                description: "<em>For the Greater Hood</em>, an organization with a heart to show the love of Jesus Christ by helping those in greatest need, planned and arranged a special weekend pop-up shop in Paterson, NJ. For three days, the store was open to the homeless and underprivileged members of the community who were welcomed to 'shop' amongst racks of donated clothing. Volunteers were eager to help customers find what they needed, and to keep the store neatly arranged. Rather than simply being handed donated items, the guests were able to select their own styles and 'check out' with their gift cards, providing them with a sense of dignity and pride in their experience. Guests left the store, some with fresh haircuts from volunteer hairdressers, many having prayed with volunteers, and all with a bag full of their findings along with a copy of the Bible. For more information about <em>For the Greater Hood</em>, please <a href='https://forthegreaterhood.com/' target='_blank'>click here</a>.",
                filter: "ForTheGreaterHood"
            }, {
                image: "/assets/images/missions/pr/feb18b.jpg",
                title: "Utuado, PR",
                date: "February 2018",
                description: 'Returning to Puerto Rico for a second trip with <a href="http://www.myneighborpr.org" target="_blank">My Neighbor PR</a>, our congregants visited more remote locations, where assistance and supplies were extremely difficult to come by. Prayers accompanied each distribution of food, water and supplies, along with a reminder that the gifts were provided by Jesus, who has already given the greatest gift of all. Many were saved, and those who already knew the Lord were encouraged and uplifted.',
                filter: "PuertoRico"
            }, {
                image: "/assets/images/missions/pr/dec17b.jpg",
                title: "Las Marias, PR",
                date: "December 2017",
                description: 'Teaming up with <a href="http://www.myneighborpr.org" target="_blank">My Neighbor PR</a>, a couple of our congragrants went to Puerto Rico to distribute food, water and toiletries to those greatly affected by Hurricane Maria, who had been without proper shelter, adequate food, or electricity for months. On this trip, they were able to bring the hope and joy of Jesus to those who lost everything. More important than the provisions were the prayers, love, and the good news of a Savior who is the Fountain of Living Water, and the Bread of Life. Many received Jesus as their Lord and Savior during the mission.',
                filter: "PuertoRico"
            }]
        }
    }
};
</script>

<style scoped>
section {
    padding: 4.5rem 3rem 3.5rem 4rem;
}

.title {
    font-weight: normal;
    font-size: 2.5rem;
    margin-bottom: 1rem;
    letter-spacing: 0.06rem;
}

.image {
    padding-right: 0;
}

.Location .image {
    background: url(/assets/images/map.png);
    height: 600px;
    background-size: cover;
    background-position: center;
    filter: grayscale(100%);
}

tr {
    border: none;
}

td {
    vertical-align: top;
}
i.ln {
    font-size: 2rem;
}

.card-image {
    position: relative;
}

.date {
    text-transform: uppercase;
    font-size: 1rem;
    padding-bottom: 1rem;
    display: block;
}

.description {
    font-size: 1.5rem;
    line-height: 1.25;
}

.overlay {
    position: absolute;
    /* top: 0px; */
    bottom: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(0deg, rgba(0, 0, 0, .8), rgba(0, 0, 0, .0) 100%);
    height: 75%;
    z-index: 1;
}

.card-title {
    z-index: 2;
    font-family: 'NewhouseDTCond-ExtBold';
}

.card:hover {
    -webkit-box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
    box-shadow: 0 16px 24px 2px rgba(0,0,0,0.14), 0 6px 30px 5px rgba(0,0,0,0.12), 0 8px 10px -7px rgba(0,0,0,0.2);
}

.card .card-action a:not(.btn):not(.btn-large):not(.btn-small):not(.btn-large):not(.btn-floating) { 
    text-transform: none;
    font-size: 1.25rem;
}

.role {
    display: block;
    font-size: 1rem;
    line-height: 1;
    text-transform: uppercase;
}

.name {
    display: block;
    font-family: 'NewhouseDTCond-ExtBold';
    font-size: 1.75rem;
    line-height: 1.25;
}

p {
    margin-top: 1rem;
    font-size: 1.25rem;
}

i.filter {
    color: #000;
}

@media screen and (min-width: 1901px) {
    .card.horizontal .card-image:first-child {
        max-width: 38.3%;
    }
    .card.horizontal .card-content .card-image {
        display: none;
    }
}
@media screen and (max-width: 1900px) {
    .card.horizontal .card-image:first-child {
        display: none;
    }

    .card.horizontal .mission-name-div {
        display: inline-block;
        position: relative;
        bottom: 10px;
    }

    .card.horizontal .card-content .card-image {
        display: inline-block;
        margin-right: 1.5rem;
    }

    .card.horizontal .card-content .card-image img {
        border-radius: 50%;
        width: 65px;
    }
}

@media screen and (min-width: 1270px) {
    /* .card.horizontal {
        height: 445px;
    }
    .card.horizontal .card-image {
        max-width: 38%;
    } */
}
@media screen and (max-width: 1200px){
    .clear {
        display: none;
    }
}

@media screen and (max-width: 992px) {
    section {
        padding: 4.5rem 1rem 3.5rem 1rem;
    }
}
</style>